import { GetArticleAlternativeResponse } from "./model"

export function mapAlternativeArticles(response: GetArticleAlternativeResponse) {
    return response?.alternativesContext?.articles ?? []
}
